export default "__VITE_ASSET__Dx3Lctpr__"